import { render, staticRenderFns } from "./ManageItems.vue?vue&type=template&id=531da050"
import script from "./ManageItems.vue?vue&type=script&lang=js"
export * from "./ManageItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports